import { render, staticRenderFns } from "./fishStandard.vue?vue&type=template&id=629fae1f"
import script from "./fishStandard.vue?vue&type=script&lang=js"
export * from "./fishStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports